<template>
    <v-card
      class="mx-auto pa-2"
      outlined
      v-if="_.get(leader, 'id', null)"
    >
      <!-- // ID User Check
      {{leader.id}} -->
      <v-list-item one-line>
        <v-list-item-content>
          <div class="leader-profile">
            <v-row >
              <v-col
                cols="12"
                md="6"
              >
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="image-profile">
                      
                      <img 
                        class="sale-leader-report-img"
                        v-if="_.get(leader, 'avatar.id', null)"
                        :src="_.get(leader, 'avatar.filePath', '')"
                        alt=""
                      >
                      <img 
                        class="sale-leader-report-img"
                        v-else 
                        src="@/assets/default-avatar.jpg" 
                      />
                    </div>
                  </v-col>
                    <v-col cols="12" md="6" class="d-flex flex-column justify-center" >
                      <h3 class="display-2 font-weight-medium mb-7">{{_.get(leader, 'fullName', '')}}</h3>
                      <p class="display-1">{{_.get(leader, 'department.name', '')}}</p>
                  </v-col>
                </v-row>

              </v-col>
              <v-col
                   v-if="report.kpi !== ''"
                   cols="12" md="6" class="d-flex flex-column justify-center"
              >
                <h3 class="display-2 font-weight-medium mb-7">Hoàn thành KPI</h3>
                <v-progress-linear
                  :value="parseInt(_.get(this.report, 'kpi', 0)  || 0)"
                  color="success"
                  height="25"
                >
                  <template v-slot="{ value }">
                    <strong>{{ Math.round(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
          </div>

          <v-simple-table class="data-salse-leader">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center display-1">Doanh thu thành công</th>
                  <th class="text-center display-1">Tỉ lệ chốt thành công</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{formatPrice(+report.successTurnOver)}}/{{formatPrice(+report.initTurnOver)}}</td>
                  <td class="text-center">{{ +report.successLatchRatio + '%' }}/{{ +report.initLatchRatio + '%' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-list-item-content>
      </v-list-item>
    </v-card>
</template>

<script>
  import { formatPrice } from '@/helpers/utils'
  export default {
    props: {
      leader: {
        default: () => ({})
      },
      report: {
        default: () => ({})
      }
    },
    data () {
      return {
        rank: ''
      }
    },
    created() {

    },
    methods: {
      getRank(status) {
        if (status == 'asc') {
          return 'up'
        } else if (status == 'desc') {
          return 'down'
        } else {
          return 'other'
        }
      }
    },
  }
</script>

<style lang="scss">

  .data-salse-leader {
    .v-avatar {
      border: 3px solid #000;
      border-radius: 100%;
      background-color: transparent!important;
    }
    .up {
      border-color: green;
    }
    .down {
      border-color: red;
    }
    .other {
      border-color: yellow;
    }
  }

  .leader-profile {
    .image-profile {
      margin: 0 auto;
      max-width: 220px;
      max-height: 220px;
      width: 100%;
      height: 100%;
      .sale-leader-report-img {
        max-width: 200px;
        max-height: 200px;
        width: 200px;
        height: 200px;
        display: inline-block;
      }
    }
  }
</style>
